// extracted by mini-css-extract-plugin
export default {"brandBlack":"#252422","brandDarkGrey":"#403d39","brandLightGrey":"#b1aba1","brandWhite":"#fffcf2","codeFontStack":"\"Fira Code\",monospace"};